import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux';
import { ModalConsulta } from '.';
import { Tabela } from '../Basicos';
import { MenuTable } from '../Menu';
import { axiosApi } from '../Basicos/axiosInstances';
import * as actionsRedux from '../Store/Actions/index';

function ModalConsultaAcompanhamentoSelecaoGrupo(props) {
    const { estrutura, ativar } = props;
    const { alunos, header } = estrutura?.modal;

    // A lista e os totais do header vêm prontos do backend a cada consulta — guardados em
    // estado local só pra dar pra atualizar na hora (otimista) quando uma seleção é removida,
    // sem precisar refazer a consulta inteira via filtro/redux.
    const [linhas, setLinhas] = useState(alunos);
    const [totais, setTotais] = useState(header?.dados);

    useEffect(() => {
        setLinhas(alunos);
        setTotais(header?.dados);
    }, [alunos, header]);

    const removerSelecao = async (alunoId) => {
        try {
            await axiosApi.delete(`/consultas/acompanhamento-selecao-grupo/${alunoId}`, {
                params: {
                    periodo_letivo_id: totais.periodoLetivoId,
                    semestre_id: totais.semestreId,
                },
            });

            setLinhas((anterior) => anterior.map((linha) =>
                linha.aluno_id === alunoId
                    ? { ...linha, nome: null, matricula: null, aluno_id: null, matriculado: null }
                    : linha
            ));
            setTotais((anterior) => ({
                ...anterior,
                totalSelecionado: anterior.totalSelecionado - 1,
                totalNaoSelecionado: anterior.totalNaoSelecionado + 1,
            }));

            ativar(201, 'A seleção de grupo do aluno foi removida com sucesso!');
        } catch (error) {
            const mensagem = error?.response?.data?.erro || 'Algo deu errado ao remover a seleção.';
            ativar(400, mensagem);
        }
    };

    const columns = React.useMemo(
        () => [{
            Header: "Alunos",
            style: {
                display: 'none',
            },
            columns: [
                {
                    Header: 'Grupo',
                    accessor: 'grupo_escolhido',
                },
                {
                    Header: 'Nome',
                    accessor: 'nome',
                },
                {
                    Header: 'Matrícula',
                    accessor: 'matricula',
                },
                {
                    Header: 'Matriculado',
                    accessor: 'matriculado',
                    Cell: ({ row }) => row.original.aluno_id
                        ? (row.original.matriculado ? 'Sim' : 'Não')
                        : null,
                },
                {
                    Header: '',
                    accessor: 'acoes',
                    resizable: false,
                    style: { width: 64 },
                    // Só dá pra remover quem ainda não virou matrícula de verdade — depois disso
                    // a correção é na tela de Alunos, não aqui (o backend também trava isso).
                    Cell: ({ row }) => (row.original.aluno_id && !row.original.matriculado) ? (
                        <MenuTable
                            iconRemover={true}
                            removerOnClick={() => removerSelecao(row.original.aluno_id)}
                        />
                    ) : null,
                },
            ],
        }],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [totais]
    )

    return (
        <ModalConsulta
            data={props.data}
            modalClass="modal-map"
            modalBodyClass="modalConsulta"
            size="lg"

            {...props}
        >
            <Tabela
                columns={columns}
                data={linhas}
                tabelaClassName="tabelaConsulta"
            />
        </ModalConsulta>
    );
}

const mapDispatchToProps = (dispatch) => {
    return {
        ativar: (tipo, acao) => dispatch(actionsRedux.ativarAlert(tipo, acao)),
    }
}

export default connect(null, mapDispatchToProps)(ModalConsultaAcompanhamentoSelecaoGrupo);
